import { render, staticRenderFns } from "./TableDemonstrative.vue?vue&type=template&id=53aa30b1"
import script from "./TableDemonstrative.vue?vue&type=script&lang=js"
export * from "./TableDemonstrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53aa30b1')) {
      api.createRecord('53aa30b1', component.options)
    } else {
      api.reload('53aa30b1', component.options)
    }
    module.hot.accept("./TableDemonstrative.vue?vue&type=template&id=53aa30b1", function () {
      api.rerender('53aa30b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MonitoringReport/components/TableDemonstrative.vue"
export default component.exports